module.exports = __webpack_public_path__ + "static/media/player-right.845271dd.svg";